import axios from "axios";
import { useState, useEffect } from "react";
import GetLatLngOnly from "../../../properties/components/shared/GetLatLngOnlyPure";
import Swal from "sweetalert2";
import ImagesUpload from "../../../properties/components/forms/ImagesUpload";
import Cookies from "js-cookie";
import localforage from "localforage";
import { MdKeyboardArrowUp, MdKeyboardArrowDown } from "react-icons/md";
import { motion } from "framer-motion";
import tokenService from "../../../../../utils/tokenService";

const dbName = "DataLead";
localforage.config({
  name: dbName,
  storeName: "Data_Lead_Asset",
  description: "Store(lat,lng,phone_number,description,images)",
});

const LeadAssets = () => {
  const [textCheckPhoneNumber, setTextCheckPhoneNumber] = useState("กรุณากรอกเบอร์โทรศัพท์ 10 หลัก");
  const [errorMsgPopUp, setErrorMsgPopUp] = useState("");

  const checkPhoneNumber = (number) => {
    if (number.length > 10) {
      setTextCheckPhoneNumber("กรุณาระบุเบอร์โทรแค่ 10 หลัก");
    } else if (number !== "" && number.length === 10) {
      axios
        .get(`${process.env.REACT_APP_API}/event/checkExistedlead/${number}`)
        .then((res) => setTextCheckPhoneNumber(res.data.message))
        .catch(() => {});
    }
  };

  const [upload, setUpload] = useState({
    lat: null,
    lng: null,
    phone_number: "",
    description: "",
    images: [],
    asset_type: "house",
    type_post: ["ขาย"],
  });
  const { lat, lng, phone_number, description, images, asset_type, type_post } = upload;

  const [isValidLocation, setIsValidLocation] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [lengthOfDetailPost, setLengthOfDetailPost] = useState(0);
  const [assetLocationLatitude, setAssetLocationLatitude] = useState(null);
  const [assetLocationLongitude, setAssetLocationLongitude] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);

  useEffect(() => {
    const storeUploadData = async () => {
      try { await localforage.setItem("uploadData", upload); } catch (_) {}
    };
    storeUploadData();
  }, [upload]);

  useEffect(() => {
    const retrieveUploadData = async () => {
      try {
        const saved = await localforage.getItem("uploadData");
        if (saved) setUpload(saved);
      } catch (_) {}
    };
    retrieveUploadData();
  }, []);

  useEffect(() => {
    if (phone_number.length < 10) setTextCheckPhoneNumber("กรุณากรอกเบอร์โทรศัพท์ 10 หลัก");
  }, [phone_number]);

  useEffect(() => {
    setUpload((prev) => ({
      ...prev,
      lat: assetLocationLatitude?.asset_location_latitude ?? "",
      lng: assetLocationLongitude?.asset_location_longitude ?? "",
    }));
  }, [assetLocationLatitude, assetLocationLongitude]);

  const inputValue = (name) => (e) => setUpload({ ...upload, [name]: e.target.value });

  const handleDetailPostLimit = (e) => {
    if (e.target.value.length <= 999) {
      setLengthOfDetailPost(e.target.value.length);
      setUpload((prev) => ({ ...prev, description: e.target.value }));
    } else {
      Swal.fire({ icon: "error", title: "เกินจำนวนตัวอักษรที่กำหนด", text: "สูงสุด 999 ตัวอักษร", showConfirmButton: false, timer: 1500 });
    }
  };

  const removeUploadData = async () => {
    try {
      await localforage.removeItem("uploadData");
      await Swal.fire("ส่งข้อมูลสำเร็จ", "", "success");
      setIsUploading(false);
      window.location.replace("/home");
    } catch (_) {
      setIsUploading(false);
    }
  };

  const handleLeadAssetSendToDashboardAdmin = async () => {
    setIsUploading(true);
    const token = await tokenService.ensureFreshToken();

    if (!token) {
      Swal.fire("", "กรุณาเข้าสู่ระบบใหม่อีกครั้ง", "error");
      setIsUploading(false);
      return;
    }

    if (!isValidLocation && typeof lat === "string") {
      Swal.fire("", "กรุณาปักหมุดหรือ เลือกไม่มีตำแหน่ง", "error");
      setIsUploading(false);
      return;
    }

    axios
      .post(
        `${process.env.REACT_APP_API}/mlm/lead`,
        { lat, lng, phone_number, description, images, asset_type, type_post },
        { headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" } }
      )
      .then(async (res) => {
        const marker_data = res?.data?.data;
        const location = marker_data?.location;
        if (location?.lat != null) {
          localStorage.setItem("positionBeforeExitedPage", JSON.stringify(marker_data));
          localStorage.setItem("LatForRecommendedAssets", location.lat);
          localStorage.setItem("LngForRecommendedAssets", location.lng);
        }
        await removeUploadData();
      })
      .catch((err) => {
        setIsUploading(false);
        const errData = err?.response?.data;
        const errMsg = errData?.Error || errData?.error;

        if (errMsg === "Corrupted files detected") {
          Swal.fire({
            title: `รูปเกิดความเสียหาย (รูปที่ ${errData?.CorruptedFilePage}) ต้องการข้ามภาพที่เสียหรือไม่?`,
            showDenyButton: true,
            confirmButtonText: "ลบรูปเสียทั้งหมด",
            denyButtonText: "ขอตรวจสอบรูปภาพ",
          }).then((result) => {
            if (result.isConfirmed) {
              setUpload((prev) => ({
                ...prev,
                images: images.filter((_, idx) => !errData?.CorruptedFileIndex?.includes(idx)),
              }));
            }
          });
        } else if (errMsg === "กรุณากรอก เบอร์โทร ของป้ายประกาศขายที่ติดอยู่หน้าทรัพย์") {
          Swal.fire("", errMsg, "error");
        } else if (errMsg) {
          setErrorMsgPopUp(errMsg);
        } else {
          Swal.fire("ส่งไม่สำเร็จ", err?.message || "เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง", "error");
        }
      });
  };

  function handleCheckboxValidLocation() {
    setIsValidLocation(!isValidLocation);
    if (isValidLocation && lat === null && lng === null) setUpload({ ...upload, lat: null, lng: null });
  }

  const listTypeAssets = [
    { label: "บ้านเดี่ยว", key: "house" },
    { label: "คอนโด", key: "condo" },
    { label: "ทาวน์เฮ้าส์", key: "townhouse" },
    { label: "ที่ดิน", key: "land" },
    { label: "อาคารพาณิชย์", key: "commercial" },
    { label: "โกดัง/โรงงาน", key: "other" },
  ];

  const listTypePost = [
    { label: "ขาย", key: "sell" },
    { label: "เช่า", key: "rent" },
    { label: "เซ้ง", key: "sell_out" },
  ];

  const phoneStatus =
    textCheckPhoneNumber === "เบอร์โทรนี้ไม่ได้เป็นสมาชิก สามารถส่งข้อมูลเข้ามาได้"
      ? "ok"
      : textCheckPhoneNumber === "กรุณากรอกเบอร์โทรศัพท์ 10 หลัก"
      ? "neutral"
      : "error";

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-2xl mx-auto px-4 py-8 space-y-4">

        {/* ── Header ── */}
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4 }}
          className="flex items-center gap-3"
        >
          <button
            onClick={() => window.location.replace("/profiles")}
            className="w-9 h-9 bg-white rounded-xl flex items-center justify-center border border-gray-200 shadow-sm hover:bg-gray-50 transition-colors flex-shrink-0"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
            </svg>
          </button>
          <div>
            <p className="text-xs text-gray-400 uppercase tracking-wider mb-0.5">PostPerty</p>
            <h1 className="text-lg font-bold text-gray-900">แจ้งทรัพย์ให้ PostPerty (Lead)</h1>
          </div>
        </motion.div>

        {/* ── Error banner ── */}
        {errorMsgPopUp && (
          <motion.div
            initial={{ opacity: 0, y: -8 }}
            animate={{ opacity: 1, y: 0 }}
            className="bg-red-50 border border-red-100 rounded-2xl px-5 py-3.5 flex items-center justify-between"
          >
            <p className="text-sm font-semibold text-red-600">{errorMsgPopUp}</p>
            <button onClick={() => setErrorMsgPopUp("")} className="text-red-400 hover:text-red-600 ml-3 flex-shrink-0">
              <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </motion.div>
        )}

        {/* ── Phone number ── */}
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, delay: 0.04 }}
          className="bg-white rounded-2xl shadow-sm border border-gray-100 p-5"
        >
          <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-3">ข้อมูลการติดต่อ</p>
          <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-1.5">
            เบอร์โทรศัพท์เจ้าของทรัพย์ <span className="text-red-400">*</span>
          </label>
          <input
            type="text"
            placeholder="0XX-XXX-XXXX"
            onChange={(e) => { inputValue("phone_number")(e); checkPhoneNumber(e.target.value); }}
            className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl text-sm text-gray-800 placeholder-gray-400 focus:outline-none focus:border-blue-400 focus:bg-white transition-colors"
          />
          {phone_number.length > 0 && (
            <p
              className="text-xs mt-1.5 font-medium"
              style={{
                color:
                  phoneStatus === "ok" ? "#16a34a" :
                  phoneStatus === "error" ? "#ef4444" :
                  "#ca8a04",
              }}
            >
              {textCheckPhoneNumber}
            </p>
          )}
        </motion.div>

        {/* ── Images ── */}
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, delay: 0.06 }}
          className="bg-white rounded-2xl shadow-sm border border-gray-100 p-5"
        >
          <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-3">รูปภาพ</p>
          <ImagesUpload
            images={images}
            upload={upload}
            setUpload={setUpload}
            setPageNumber={setPageNumber}
          />
        </motion.div>

        {/* ── Location ── */}
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, delay: 0.08 }}
          className="bg-white rounded-2xl shadow-sm border border-gray-100 p-5"
        >
          <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-3">ตำแหน่งทรัพย์</p>
          <label className="flex items-center gap-2.5 cursor-pointer mb-4" onClick={handleCheckboxValidLocation}>
            <div className={`w-5 h-5 rounded flex items-center justify-center border-2 transition-colors ${isValidLocation ? "bg-blue-600 border-blue-600" : "border-gray-300 bg-white"}`}>
              {isValidLocation && (
                <svg xmlns="http://www.w3.org/2000/svg" className="w-3 h-3 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                </svg>
              )}
            </div>
            <span className="text-sm text-gray-600">ไม่มีตำแหน่ง / ไม่ทราบตำแหน่ง</span>
          </label>

          {!isValidLocation && (
            <div className="w-full h-[400px] rounded-xl overflow-hidden relative">
              <div className="w-8 h-8 absolute right-2 top-24 z-10 md:hidden bg-white rounded-full shadow flex items-center justify-center">
                <MdKeyboardArrowUp className="w-5 h-5" />
              </div>
              <div className="w-8 h-8 absolute right-2 bottom-24 z-10 md:hidden bg-white rounded-full shadow flex items-center justify-center">
                <MdKeyboardArrowDown className="w-5 h-5" />
              </div>
              <GetLatLngOnly
                setAssetLocationLatitude={setAssetLocationLatitude}
                setAssetLocationLongitude={setAssetLocationLongitude}
                latLeadDataUserClickBeforeExitPage={lat}
                lngLeadDataUserClickBeforeExitPage={lng}
              />
            </div>
          )}
        </motion.div>

        {/* ── Asset type ── */}
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, delay: 0.1 }}
          className="bg-white rounded-2xl shadow-sm border border-gray-100 p-5"
        >
          <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-3">ประเภทอสังหาฯ</p>
          <div className="grid grid-cols-3 gap-2">
            {listTypeAssets.map((data, idx) => (
              <button
                key={idx}
                onClick={() => setUpload({ ...upload, asset_type: data.key })}
                className={`py-2.5 text-sm font-semibold rounded-xl transition-colors ${data.key === asset_type ? "bg-blue-600 text-white" : "bg-gray-50 text-gray-600 border border-gray-200 hover:bg-gray-100"}`}
              >
                {data.label}
              </button>
            ))}
          </div>
        </motion.div>

        {/* ── Post type ── */}
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, delay: 0.12 }}
          className="bg-white rounded-2xl shadow-sm border border-gray-100 p-5"
        >
          <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-3">ประเภทการขาย</p>
          <div className="grid grid-cols-3 gap-2">
            {listTypePost.map((data, idx) => {
              const isSelected = type_post.includes(data.label);
              return (
                <button
                  key={idx}
                  onClick={() => {
                    setUpload({
                      ...upload,
                      type_post: isSelected
                        ? type_post.filter((t) => t !== data.label)
                        : [...type_post, data.label],
                    });
                  }}
                  className={`py-2.5 text-sm font-semibold rounded-xl transition-colors ${isSelected ? "bg-blue-600 text-white" : "bg-gray-50 text-gray-600 border border-gray-200 hover:bg-gray-100"}`}
                >
                  {data.label}
                </button>
              );
            })}
          </div>
        </motion.div>

        {/* ── Description ── */}
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, delay: 0.14 }}
          className="bg-white rounded-2xl shadow-sm border border-gray-100 p-5"
        >
          <div className="flex items-center justify-between mb-3">
            <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider">รายละเอียด</p>
            <span
              className="text-xs font-medium"
              style={{
                color:
                  lengthOfDetailPost >= 950 ? "#ef4444" :
                  lengthOfDetailPost >= 800 ? "#ca8a04" :
                  "#9ca3af",
              }}
            >
              {lengthOfDetailPost}/999
            </span>
          </div>
          <textarea
            defaultValue={description}
            onChange={handleDetailPostLimit}
            placeholder="กรอกรายละเอียดทรัพย์..."
            className="w-full h-40 px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl text-sm text-gray-800 placeholder-gray-400 focus:outline-none focus:border-blue-400 focus:bg-white transition-colors resize-none"
          />
        </motion.div>

        {/* ── Submit ── */}
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, delay: 0.16 }}
        >
          <button
            onClick={handleLeadAssetSendToDashboardAdmin}
            disabled={isUploading}
            className="w-full py-3.5 bg-blue-600 text-white text-sm font-semibold rounded-xl hover:bg-blue-700 transition-colors disabled:opacity-70 flex items-center justify-center gap-2"
          >
            {isUploading ? (
              <>
                <svg className="animate-spin w-4 h-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z" />
                </svg>
                กำลังอัปโหลด...
              </>
            ) : "ส่งข้อมูลให้ PostPerty"}
          </button>
        </motion.div>

        <div className="h-8" />
      </div>
    </div>
  );
};

export default LeadAssets;
